import { render, staticRenderFns } from "./menuSubItem.vue?vue&type=template&id=575b2e63&scoped=true&"
import script from "./menuSubItem.vue?vue&type=script&lang=js&"
export * from "./menuSubItem.vue?vue&type=script&lang=js&"
import style0 from "./menuSubItem.vue?vue&type=style&index=0&id=575b2e63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575b2e63",
  null
  
)

export default component.exports